import { Outlet } from 'react-router';

import { useIsValwinAdmin } from '~features/valwin-admin';

import { AccessDenied } from './AccessDenied';

export function ValwinAdminGuard() {
  const { isValwinAdmin } = useIsValwinAdmin();

  if (!isValwinAdmin) {
    return <AccessDenied />;
  }

  return <Outlet />;
}
